module.exports = __webpack_public_path__ + "static/media/supplierIcon.aced1fcc.svg";